/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_UntitledInputs */

const zh_learn_untitled = /** @type {(inputs: Learn_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名`)
};

const en_learn_untitled = /** @type {(inputs: Learn_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const es_learn_untitled = /** @type {(inputs: Learn_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Learn_UntitledInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_untitled = /** @type {((inputs?: Learn_UntitledInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_UntitledInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_untitled(inputs)
	if (locale === "en") return en_learn_untitled(inputs)
	return es_learn_untitled(inputs)
});